import { shallow } from 'zustand/shallow'

import { useReportStore } from '@/modules/report/useReportsStore'
import { DEFAULT_CHART_COLORS } from '@/modules/shared/constants/default-chart-colors'

const fallbackColors = {
  bg: 'rgba(200, 200, 200, 0.5)',
  bc: 'rgb(200, 200, 200)',
}

export function useChartSalesByProductReport() {
  const { loading, jsonSalesByProduct } = useReportStore(
    (state) => ({
      loading: state.loading,
      jsonSalesByProduct: state.jsonSalesByProduct,
    }),
    shallow,
  )

  const dataInfo = {
    labels: [],
    dataValue: [],
    bg: [],
    bc: [],
  }

  jsonSalesByProduct?.familias?.map((item, index) => {
    dataInfo.labels.push(item.descricao)
    dataInfo.dataValue.push(item.quantidade)

    const color = DEFAULT_CHART_COLORS[index] || fallbackColors
    dataInfo.bg.push(color.bg)
    dataInfo.bc.push(color.bc)

    return ''
  })

  const chartData = {
    labels: dataInfo.labels,
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
      },
    },
    datasets: [
      {
        label: 'Qtd',
        data: dataInfo.dataValue,
        backgroundColor: dataInfo.bg,
        borderColor: dataInfo.bc,
        borderWidth: 1,
      },
    ],
  }

  return {
    loading,
    jsonSalesByProduct,
    chartData,
  }
}
